__turbopack_context__.v({
  "categorySection": "UKGixG_categorySection",
  "categorySeparator": "UKGixG_categorySeparator",
  "categoryTitle": "UKGixG_categoryTitle",
  "contentLayout": "UKGixG_contentLayout",
  "errorContainer": "UKGixG_errorContainer",
  "mainContent": "UKGixG_mainContent",
  "mobileComparisonCTA": "UKGixG_mobileComparisonCTA",
  "mobileComparisonCloseButton": "UKGixG_mobileComparisonCloseButton",
  "mobileComparisonContainer": "UKGixG_mobileComparisonContainer",
  "mobileComparisonContent": "UKGixG_mobileComparisonContent",
  "mobileGenderOption": "UKGixG_mobileGenderOption",
  "mobileGenderOptionText": "UKGixG_mobileGenderOptionText",
  "mobileGenderOptions": "UKGixG_mobileGenderOptions",
  "mobileGenderSection": "UKGixG_mobileGenderSection",
  "mobileGenderTitle": "UKGixG_mobileGenderTitle",
  "mobileHeader": "UKGixG_mobileHeader",
  "mobileRadioButton": "UKGixG_mobileRadioButton",
  "otherTestsPlansGrid": "UKGixG_otherTestsPlansGrid",
  "plansComparisonSeparator": "UKGixG_plansComparisonSeparator",
  "plansGrid": "UKGixG_plansGrid",
});
